"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductViewer = void 0;
const react_1 = __importStar(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const react_resizable_panels_1 = require("react-resizable-panels");
const product_viewer_styles_1 = require("./product-viewer.styles");
const table_container_1 = require("./table/table.container");
const common_1 = require("../components/common");
const formal_attributes_1 = require("../formal-attributes");
const generic_1 = require("../../generic");
const localization_1 = require("../../localization");
const components_1 = require("../components");
const nodes_tree_context_1 = require("../contexts/nodes-tree.context");
const ProductViewer = () => {
    const [lastSelectedRowId, setLastSelectedRowId] = (0, react_1.useState)(null);
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    return (react_1.default.createElement(formal_attributes_1.FormalAttributesProvider, null, react_1.default.createElement(generic_1.StyledPageContainer, null, react_1.default.createElement(nodes_tree_context_1.NodesTreeProvider, null, react_1.default.createElement(react_resizable_panels_1.PanelGroup, { direction: 'horizontal' }, react_1.default.createElement(react_resizable_panels_1.Panel, { defaultSize: 30 }, react_1.default.createElement(components_1.SideBarContainer, null)), react_1.default.createElement(common_1.StyledResizeHandle, null), react_1.default.createElement(react_resizable_panels_1.Panel, null, react_1.default.createElement(ui_components_1.PageTitle, { title: t({ key: 'PRODUCT_VIEWER' }), description: t({ key: 'PRODUCT_VIEWER_DESCRIPTION' }) }), react_1.default.createElement(product_viewer_styles_1.StyledTableWrapper, null, react_1.default.createElement(table_container_1.ProductViewerTableContainer, { lastSelectedRowId: lastSelectedRowId, setLastSelectedRowId: setLastSelectedRowId }))))))));
};
exports.ProductViewer = ProductViewer;
exports.default = exports.ProductViewer;
